function handleEvtClicks(actionType, customParams) {
    // Initialize gtag.js
    window.dataLayer = window.dataLayer || [];

    // function window.gtag() {
    //     dataLayer.push(arguments);
    // }
    // window.gtag('js', new Date());

    // Set default custom parameters
    var defaultParams = {
        'event_category': 'interaction',
        'event_label': 'Default Label'
    };

    // Merge custom parameters with default parameters
    var params = Object.assign({}, defaultParams, customParams);

    // Add click or input event listener to element
    if (actionType === 'click') {
        // element.addEventListener('click', function () {
        //     // Send click event to Google Analytics with custom parameters
        //     window.gtag('event', 'click', params);
        // });
        window.gtag('event', 'click', params);

    } else if (actionType === 'input') {
        // element.addEventListener('input', function () {
        //     // Send input event to Google Analytics with custom parameters
        //     window.gtag('event', 'input', params);
        // });
        window.gtag('event', 'input', params);

    } else {
        window.gtag('event', actionType, params);

    }
}

function handlePageViews() {
    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: window.location,
            title: window.title
        }
    });
}

// Sensitive query parameters are moved out of the URL by
// public/strip-sensitive-params.js before analytics loads, so read them from
// history.state first and only fall back to the URL.
function getUrlParam(name) {
    var stashed = window.history.state && window.history.state.omUrlParams;
    if (stashed && stashed[name] != null) {
        return stashed[name];
    }
    return new URLSearchParams(window.location.search).get(name);
}

// Compares two strings in time that depends only on their length, so the
// result does not reveal how many leading characters match.
function constantTimeEqual(a, b) {
    var left = String(a);
    var right = String(b);
    var length = Math.max(left.length, right.length);
    var diff = left.length ^ right.length;
    for (var i = 0; i < length; i++) {
        diff |= (left.charCodeAt(i) || 0) ^ (right.charCodeAt(i) || 0);
    }
    return diff === 0;
}

export {
    handleEvtClicks,
    handlePageViews,
    getUrlParam,
    constantTimeEqual
}